require('./bootstrap');
require('./particles');

require('datatables.net-bs4');

require('./custom/main');
